import React from 'react';

const bind_force_update_on_events = (self, device, props) => {
    const bound_force_update = () => self.forceUpdate();
    const spec = {};
    for (const propname of props) spec[propname] = bound_force_update;
    device.bind(spec);
};

export const subscribeToDevice = (Component, device_props) => {
    return class extends React.Component {
        static displayName = `${Component.name || Component.displayName} [subscriber]`;

        componentDidMount() {
            this._bind_to(this.props.device);
        }

        _bind_to(device) {
            this._device_bindings?.unbind();
            this._device_bindings = null;
            if (device != null)
                this._device_bindings = bind_force_update_on_events(
                    this,
                    device,
                    device_props
                );

            this.forceUpdate();
        }

        componentDidUpdate(prevProps) {
            if (prevProps.device !== this.props.device)
                this._bind_to(this.props.device);
        }

        componentWillUnmount() {
            this._bind_to(null);
        }

        render() {
            const {device, ...rest} = this.props;
            const devprops = {};
            if (device != null) {
                for (const propname of device_props)
                    devprops[propname] = device[propname]();
            }

            return React.createElement(Component, {...rest, ...devprops});
        }
    };
};
